import React, { useState, useEffect } from 'react'
import { validateURL } from 'shared/helpers/validate'
import Button from 'components/controls/button'
import history from 'routes/history'
import ConfirmEditConferenceLinkModal from 'containers/dashboard/confirm-edit-conference-link-modal'
import TranslationsModal from 'containers/dashboard/translations-modal'
import { propEq } from 'ramda'
import { Spinner } from '@blueprintjs/core'
import { sortAlphabetically, addTranslationsLabel } from 'shared/helpers/functional'
import ReactQuill from 'react-quill';
import InconsistentMeetingInformationModal from 'containers/dashboard/inconsistent-meeting-information-modal'
import TranslationErrorModal from 'containers/dashboard/translation-error-modal'
import PreviewConferenceLink from 'containers/dashboard/preview-conference-link'
import AddTranslationsButton from 'components/add-translations'
import ConfirmNoConferenceLinkModal from 'containers/dashboard/confirm-no-conference-link-modal'
import 'react-quill/dist/quill.snow.css';
import 'react-quill/dist/quill.bubble.css';

import 'less/conference-link-translations.less'


const ConferencelinkTranslations = props => {
    const [editedConferenceLink, setEditedConferenceLink] = useState(props.currentProject.editedConferenceLink)
    const [showConferencLinkError, setShowConferencLinkError] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')

    const [editedMeetingInformation, setEditedMeetingInformation] = useState(props.currentProject.editedMeetingInformationMap)
    const projectInProgress = propEq('projectStatusId', 2, props.currentProject)

    const chosenTranslations = props.currentProject.chosenTranslations && [...props.currentProject.chosenTranslations.values()]
    const chosenTranslationsSorted = sortAlphabetically(chosenTranslations)

    const [meetingInformationIsRequired, setMeetingInformationIsRequired] = useState(new Map())
    const [generalError, setGeneralError] = useState(false)
    const [languageTodelete, setLanguageTodelete] = useState('')
    const [showNoLinkConfirmation, setShowNoLinkConfirmation] = useState(false)
    const [isUpdateFlow, setIsUpdateFlow] = useState(false)

    const modules = {
        toolbar: [
            ['bold', 'italic', 'underline'],
            ["link"],
        ],
    }

    const formats = [
        'bold', 'italic', 'underline',
        'link',
    ]

    const addLinkMeetingInfoandTranslations = () => {
        let generalErrorKey = false
        if (editedConferenceLink.length === 0) {
            setShowNoLinkConfirmation(true)
            return
        } else if (!validateURL(editedConferenceLink)) {
            setShowConferencLinkError(true)
            setErrorMessage(props.t('conference.link.error.message'))
            setGeneralError(true)
            generalErrorKey = true
        }
        if (editedMeetingInformation.size >= 1) {
            let show400ErrorCharacters = false
            let show540ErrorCharacters = false
            let required = false
            let meetingInformationRequiredError = false
            let showModal = false
            editedMeetingInformation.forEach((value, key) => {
                if (key === "en_us") {
                    if (value.replace(/<[^>]+>/g, '').length > 400) show400ErrorCharacters = true
                    if (value.replace(/<[^>]+>/g, '').length > 0) required = true

                } else {
                    console.log("value.replace(/<[^>]+>/g, '').",value.replace(/<[^>]+>/g, ''))
                    if (value.replace(/<[^>]+>/g, '').length > 540) show540ErrorCharacters = true
                    if ((value.replace(/<[^>]+>/g, '').length === 0 && required) || (value.replace(/<[^>]+>/g, '').trim().length === 0 && required)) {
                        meetingInformationRequiredError = true
                        generalErrorKey = true
                        setGeneralError(true)
                    } else if ((value.replace(/<[^>]+>/g, '').length === 0 && required === false )|| (value.replace(/<[^>]+>/g, '').trim().length === 0 && required === false )) {
                        showModal = true
                    } else {
                        meetingInformationRequiredError = false
                    }
                }
                setMeetingInformationIsRequired(new Map(meetingInformationIsRequired.set(key, meetingInformationRequiredError)))
            }
            )
            if (show400ErrorCharacters || show540ErrorCharacters) {
                props.showSnackbarMessageError(show400ErrorCharacters ? props.t('meeting.information.error.message') : props.t('meeting.information.error.message.540'))
                props.hideSnackbarMessage()
            } else if (meetingInformationRequiredError || showConferencLinkError === true) {
                console.log("meeting information required")
            } else if (showModal) {
                props.toggleInconsistentMeetingInformationModal({ editedConferenceLink, editedMeetingInformation })
            } else if (generalErrorKey === false) {
                setMeetingInformation()
                props.addConferenceLinkMeetingInfoTranslations(editedConferenceLink, editedMeetingInformation)

            }
        }
    }

    const handleConfirmNoLink = () => {
        setShowNoLinkConfirmation(false)
        if (isUpdateFlow) {
          // Check if conference link was actually cleared (it was non-empty before)
          const conferenceLinkDidntChange =
            props.currentProject.conferenceLink.length === 0;
          let meetingInfoDidntChange = true;
          editedMeetingInformation.forEach((value, key) => {
            if (props.currentProject.meetingInformationMap.get(key)) {
              if (
                props.currentProject.meetingInformationMap.get(key) !== value
              ) {
                if (
                  value.replace(/<p><br><[/]p>/gi, "") !==
                  props.currentProject.meetingInformationMap
                    .get(key)
                    .replace(/\s\s+/g, "")
                ) {
                  meetingInfoDidntChange = false;
                }
              }
            } else {
              meetingInfoDidntChange = false;
            }
          });
          if (conferenceLinkDidntChange && meetingInfoDidntChange) {
            history.push(`/projects/${props.currentProject.id}/dashboard`);
            props.showSnackbarMessageError(props.t("no.new.changes"));
            props.hideSnackbarMessage();
          } else if (projectInProgress) {
            props.toggleEditConferenceLinkModal(
              !props.currentProject.isEditLinkConfirmationOpen,
              editedConferenceLink,
              editedMeetingInformation,
            );
          } else {
            confirmUpdateLinkMeetingInfoandTranslations();
          }
        } else if (editedMeetingInformation.size >= 1) {
          setMeetingInformation();
          props.addConferenceLinkMeetingInfoTranslations(
            editedConferenceLink,
            editedMeetingInformation,
          );
        }
        setIsUpdateFlow(false)
    }

    const updateLinkMeetingInfoandTranslations = () => {
        let generalErrorKey = false
        if (editedConferenceLink.length === 0) {
            setIsUpdateFlow(true)
            setShowNoLinkConfirmation(true)
            return
        } else if (!validateURL(editedConferenceLink)) {
            setShowConferencLinkError(true)
            setErrorMessage(props.t('conference.link.error.message'))
            setGeneralError(true)
            generalErrorKey = true
        }
        let meetingInfoDidntChange = true
        if (editedMeetingInformation.size >= 1) {
            let show400ErrorCharacters = false
            let show540ErrorCharacters = false
            let conferenceLinkDidntChange = props.currentProject.conferenceLink.length > 0 && props.currentProject.conferenceLink.trim() === editedConferenceLink.trim()
            let required = false
            let meetingInformationRequiredError = false
            let showModal = false
            editedMeetingInformation.forEach((value, key) => {
                if (key === "en_us") {
                    if (value.replace(/<[^>]+>/g, '').length > 400) show400ErrorCharacters = true
                    if (value.replace(/<[^>]+>/g, '').length > 0) required = true
                } else {
                    if (value.replace(/<[^>]+>/g, '').length > 540) show540ErrorCharacters = true
                    if ((value.replace(/<[^>]+>/g, '').length === 0 && required) || (value.replace(/<[^>]+>/g, '').trim().length === 0 && required)) {
                        meetingInformationRequiredError = true
                        generalErrorKey = true
                        setGeneralError(true)
                    } else if ((value.replace(/<[^>]+>/g, '').length === 0 && required === false) || (value.replace(/<[^>]+>/g, '').trim().length === 0 && required === false )) {
                        showModal = true
                    } else {
                        meetingInformationRequiredError = false
                    }
                    setMeetingInformationIsRequired(new Map(meetingInformationIsRequired.set(key, meetingInformationRequiredError)))

                }
                if (props.currentProject.meetingInformationMap.get(key)) {
                    if (props.currentProject.meetingInformationMap.get(key) !== value) {
                        if (value.replace(/<p><br><[/]p>/gi, '') !== props.currentProject.meetingInformationMap.get(key).replace(/\s\s+/g, '')) {
                            meetingInfoDidntChange = false
                        }
                    }
                } else {
                    meetingInfoDidntChange = false
                }
            }
            )
            props.currentProject.meetingInformationMap.forEach((value, key) => {
                if (props.currentProject.meetingInformationMap.get(key) && props.currentProject.translationsToDelete.includes(key)) {
                    meetingInfoDidntChange = false
                }
            })

            if (show400ErrorCharacters || show540ErrorCharacters) {
                props.showSnackbarMessageError(show400ErrorCharacters ? props.t('meeting.information.error.message') : props.t('meeting.information.error.message.540'))
                props.hideSnackbarMessage()
            } else if (conferenceLinkDidntChange && meetingInfoDidntChange && !showConferencLinkError) {
                setLanguageTodelete('')
                history.push(`/projects/${props.currentProject.id}/dashboard`)
                props.showSnackbarMessageError(props.t('no.new.changes'))
                props.hideSnackbarMessage()
            } else if (meetingInformationRequiredError || showConferencLinkError === true) {
                console.log("meeting information required")
            } else {
                if (projectInProgress === true && generalErrorKey === false && !showModal) {
                    props.toggleEditConferenceLinkModal(!props.currentProject.isEditLinkConfirmationOpen, editedConferenceLink, editedMeetingInformation)
                } else if (showModal) {
                    props.toggleInconsistentMeetingInformationModal({ editedConferenceLink, editedMeetingInformation })
                } else if (generalErrorKey === false) {
                    confirmUpdateLinkMeetingInfoandTranslations()
                }
            }
        }
    }


    const confirmUpdateLinkMeetingInfoandTranslations = () => {
        editedMeetingInformation.forEach((value, key) => {
            props.setMeetingInfromation({ value: value.replace(/&nbsp;/g, ''), langCode_countryCode: key, editedConferenceLink: props.editedConferenceLink })
        })
        props.editConferenceLinkDetails({
            projectId: props.currentProject.id,
            participantGroupId: props.currentProject.participantGroupId,
            conferenceLink: editedConferenceLink,
            editedMeetingInformationMap: editedMeetingInformation,
            userId: props.currentProject.userId,
            projectInProgress: projectInProgress,
        })
    }

    useEffect(() => {
        setShowConferencLinkError(false)
        setErrorMessage('')
    }, [editedConferenceLink])


    const setValues = (payload) => {
        setEditedMeetingInformation(new Map(editedMeetingInformation.set(payload.langCode_countryCode, payload.value)))
    }

    const setMeetingInformation = () => {
        props.setMeetingInfromation({ payload: Array.from(editedMeetingInformation.entries()), editedConferenceLink: editedConferenceLink })
    }

    useEffect(() => {
        const values = Array.from(meetingInformationIsRequired.values()).filter(item => item === true);
        if (values.length > 0 || showConferencLinkError === true) {
            setGeneralError(true)
        } else {
            setGeneralError(false)
        }
    }, [showConferencLinkError, editedMeetingInformation])

    const showDeleteBtn = (langCode_countryCode) => {
        setLanguageTodelete(langCode_countryCode)
    }

    const deleteTranslation = (langCode_countryCode) => {
        props.currentProject.conferenceLink.length > 0 ? props.deleteTranslation({
            translationsToDelete: langCode_countryCode,
            editedConferenceLink: editedConferenceLink,
            editedMeetingInformation: editedMeetingInformation,
            projectId: props.currentProject.id
        }) : props.deleteTranslationDirectly({
            translationsToDelete: langCode_countryCode,
            editedConferenceLink: editedConferenceLink,
            editedMeetingInformation: editedMeetingInformation,
            projectId: props.currentProject.id
        })
    }

    const handleShowPreview = (langCode_countryCode,languageName) => {
        console.log("langCode_countryCode: " , langCode_countryCode)
        const hasLink = editedConferenceLink.length > 0 
        props.getEmailTemplate(props.currentProject.id, false , !hasLink, hasLink , langCode_countryCode,languageName, undefined, hasLink)
      }

    return (
        <div>
            <div className="new-conference-link">
                <div className="conference-link">
                    <div>
                        <h3> {props.currentProject.conferenceLink.length === 0 ? props.t('add.conference.link.translations.header') : props.t('edit.conference.link.trans.header')}</h3>
                        <div className='conference-link-message'>
                            {props.t('add.conference.link.message')}
                        </div>
                        <hr />
                    </div>
                    <div>
                        {generalError &&
                            <div className="error-banner" >
                                <i className="im-warning" />
                                {props.t('meeting.info.warning.message')}
                            </div>
                        }
                        <div className="bp3-form-group showable-box">
                            <div className="showable-box-content-container">
                                <div className="side-icon">
                                    <i className="im-link2" />
                                </div>

                                <div className="showable-box-content">
                                    <div className="header">{props.t('conference.link.title')}</div>
                                    <div className="add-conference-link-body">
                                        <div className="add-conference-link-text">
                                            <span>{props.t('conference.link.title')}</span>
                                        </div>
                                        <input className={`conference-link-input${showConferencLinkError ? " error" : ""}`} type="text" name="conference-link"
                                            placeholder="Enter third-party open conferencing link"
                                            onChange={e => setEditedConferenceLink(e.target.value)}
                                            value={editedConferenceLink}
                                        />
                                        {showConferencLinkError && <div className="error-message"> {errorMessage}</div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='meeting-information-translations'>
                        <div className="bp3-form-group showable-box">
                            <div className="showable-box-content-container">
                                <div className="side-icon">
                                    <i className="im-meeting-info" />
                                </div>
                                <div className="showable-box-content">
                                    <div className="header">{props.t('meeting.information.header')}</div>
                                    {
                                        <div className="add-conference-link-body">
                                            <div className="add-conference-link-text">
                                                <span>{props.t('add.meeting.information')}</span>
                                            </div>
                                            <hr />
                                            {
                                                (chosenTranslations
                                                    && props.setMeetingInfromation
                                                    && editedMeetingInformation &&
                                                    chosenTranslations.length > 0) ?
                                                    chosenTranslationsSorted.map((item, i) => (
                                                        <div>
                                                            <div className="meeting-info" >
                                                                {
                                                                    <div className='meeting-info-header'>
                                                                        <p className='meeting-info-title'> Meeting Information: {addTranslationsLabel(props.currentProject.defaultLocalizationMap, item.langCode_countryCode, item)} </p>
                                                                        {item.langCode_countryCode !== 'en_us' && <p className="trash-logo-container">
                                                                            <button className={'im-trash'} onClick={() => showDeleteBtn(item.langCode_countryCode)} />
                                                                            {item.langCode_countryCode == languageTodelete &&
                                                                                <button id={`del-${item.langCode_countryCode}`}
                                                                                    className="remove-language-btn" onClick={() => deleteTranslation(item.langCode_countryCode)}>Delete Translation</button>}
                                                                        </p>
                                                                        }
                                                                    </div>
                                                                }
                                                                <div className={`text-editor${meetingInformationIsRequired.get(item.langCode_countryCode) === true ? ' error' : ''}`}  >
                                                                    <ReactQuill
                                                                        placeholder={item.langCode_countryCode === 'en_us' ? props.t('add.meeting.information.placeholder') : `Enter ${item.language_name} Translation`}
                                                                        modules={modules}
                                                                        formats={formats}
                                                                        value={editedMeetingInformation.get(item.langCode_countryCode) || ''}
                                                                        onChange={value => {
                                                                            if (meetingInformationIsRequired.get(item.langCode_countryCode) === true) {
                                                                                meetingInformationIsRequired.set(item.langCode_countryCode, false)
                                                                                setMeetingInformationIsRequired(meetingInformationIsRequired)
                                                                            }
                                                                            setValues({ value: value, langCode_countryCode: item.langCode_countryCode })
                                                                        }
                                                                        }
                                                                    >
                                                                    </ReactQuill>
                                                                </div>
                                                            </div>
                                                            {meetingInformationIsRequired.get(item.langCode_countryCode) === true && <div className='error-message'> {props.t('translation.required')} </div>}
                                                            {<Button
                                                                className="preview"
                                                            onClick={() =>  handleShowPreview(item.langCode_countryCode,addTranslationsLabel(props.currentProject.defaultLocalizationMap, item.langCode_countryCode, item))}
                                                            > Preview </Button>
                                                             }
                                                        </div>
                                                    )
                                                    )
                                                    : <Spinner intent="primary" />
                                            }
                                            <AddTranslationsButton
                                                currentProject={props.currentProject}
                                                toggleTranslationsModal={props.toggleTranslationsModal}
                                                editedConferenceLink={editedConferenceLink}
                                                editedMeetingInformation={editedMeetingInformation}
                                                t={props.t}
                                                languages={props.currentProject.languages}
                                                editedTopicName={props.currentProject.editedTopicNameDetails}
                                            ></AddTranslationsButton>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="action-buttons">
                <Button
                    disabled={false}
                    className="cancel-button btn-primary"
                    type="submit"
                    isLoading={props.currentProject.isSubmitting}
                    onClick={() => {
                        props.toggleEditConferenceLinkModal(props.currentProject.isEditLinkConfirmationOpen, props.currentProject.conferenceLink, props.currentProject.meetingInformationMap)
                        props.clearTranslations({flag:'meetingInformation'})
                        history.push(`/projects/${props.currentProject.id}/dashboard`)
                    }}
                >
                    Cancel
                </Button>
                <Button
                    disabled={false}
                    className="save-button btn-primary"
                    type="submit"
                    isLoading={props.currentProject.isSubmittingConferenceLink}
                    onClick={() => props.currentProject.showCopyLinkButton ? updateLinkMeetingInfoandTranslations() : addLinkMeetingInfoandTranslations()}
                >
                    {props.t('save.conference.link')}
                </Button>
            </div>
            {props.currentProject.isEditLinkConfirmationOpen && <ConfirmEditConferenceLinkModal
                isOpen={props.currentProject.isEditLinkConfirmationOpen}
                onCancel={() => props.toggleEditConferenceLinkModal(false, editedConferenceLink, editedMeetingInformation)}
                onSubmit={confirmUpdateLinkMeetingInfoandTranslations}
                isSubmitting={props.currentProject.isSubmittingConferenceLink}
                toggleEditConferenceLinkModal={props.toggleEditConferenceLinkModal}
                editedConferenceLink={editedConferenceLink}
                editedMeetingInformationMap={editedMeetingInformation}
                t={props.t}
            ></ConfirmEditConferenceLinkModal>
            }
           {props.previewConferenceLinkModal.isOpen &&    <PreviewConferenceLink
               exampleEmail = {props.exampleEmail}
               responderLanguage = {props.previewConferenceLinkModal.languageCountryCode}
               isOpen={props.previewConferenceLinkModal.isOpen}
               showSubmitBtn={false}
               props={props}
               onCancel={props.closePreviewLinkModal}
               onSubmit={props.closePreviewLinkModal}
               meetingMinutes= {props.currentProject.interviewLength}
               topicName={props.currentProject.editedTopicNameDetails}
               isSubmitting={props.currentProject.interviewBufferIsSubmitting}
               salesforceJobNumber={ props.currentProject.salesForceJobNumber}
               t={props.t}
               code={props.previewConferenceLinkModal.code}         
        ></PreviewConferenceLink>}
            <TranslationsModal
                isOpen={props.currentProject.istranslationModalOpen}
                onCancel={() => props.toggleTranslationsModal(editedConferenceLink, editedMeetingInformation)}
                onSubmit={props.addTranslations}
                t={props.t}
                getLanguageAndLocalizationData={props.getLanguageAndLocalizationData}
                currentProject={props.currentProject}
                languages={props.currentProject.languages}
                localizationMap={props.currentProject.localizationMap}
                editedConferenceLink={editedConferenceLink}
                editedMeetingInformationMap={editedMeetingInformation}
                flag={'meetingInformation'}
                editedTopicName={props.currentProject.editedTopicNameDetails}
            ></TranslationsModal>
            <InconsistentMeetingInformationModal
                isOpen={props.currentProject.toggleModal}
                onCancel={() => props.toggleInconsistentMeetingInformationModal({ editedConferenceLink, editedMeetingInformation })}
                onSubmit={() => props.toggleInconsistentMeetingInformationModal({ editedConferenceLink, editedMeetingInformation })}
                t={props.t}
            ></InconsistentMeetingInformationModal>
            <TranslationErrorModal
                isOpen={props.currentProject.toggleTranslationsModal}
                onCancel={() => props.toggleTranslationsErrorModal({ editedConferenceLink, editedMeetingInformation })}
                onSubmit={() => props.toggleTranslationsErrorModal({ editedConferenceLink, editedMeetingInformation })}
                t={props.t}
            ></TranslationErrorModal>
            <ConfirmNoConferenceLinkModal
                isOpen={showNoLinkConfirmation}
                onCancel={() => setShowNoLinkConfirmation(false)}
                onConfirm={handleConfirmNoLink}
            />

        </div>
    )
}

export default ConferencelinkTranslations
